import React, { FC } from 'react'
import { useParams } from 'react-router-dom'
import { isEmpty } from 'lodash'

import PillBoxAndSetting from 'components/Owner/Tools/PillBoxAndSetting'

import { Tool, ToolSupportLevel } from '__generated__/api-types-and-hooks'
import { IconWrapper } from 'components/Owner/Tools/style'
import { getImageUrl } from 'utils/helper'
import ToolBookmark from './ToolBookmark'

interface ICardHeadProps {
  tool: Tool
  isConnected: boolean
  isToolDisconnecting: boolean
  handleDisconnect: () => void
}
const CardHeader: FC<ICardHeadProps> = ({
  tool,
  isConnected,
  isToolDisconnecting,
  handleDisconnect,
}) => {
  const { toolSubTab } = useParams()
  const isToolConnectable = tool.supportLevel && tool.supportLevel !== ToolSupportLevel.Open
  return (
    <div className="flex flex-row justify-between items-center px-6 pb-6">
      <IconWrapper
        className="!max-w-[150px]"
        src={getImageUrl(tool.imageUrl)}
        alt={`${tool?.toolName}`}
      />
      {tool.supportLevel === ToolSupportLevel.Open && !isEmpty(toolSubTab) && (
        <ToolBookmark tool={tool} />
      )}

      {isToolConnectable && (
        <PillBoxAndSetting
          isToolDisconnecting={isToolDisconnecting}
          isConnected={isConnected || false}
          handleDisconnect={handleDisconnect}
        />
      )}
    </div>
  )
}

export default CardHeader
